import { Employee, Project, Tag, Task } from '../model/types/tasks';

export const getTasksInformation = (
    tasks: Task[],
    allProjects: Project[],
    allTags: Tag[],
    employees: Employee[]
): { projectsForFilter: Project[]; executors: Employee[] } => {
    const tagsEntities = {};
    const allTagsEntities = allTags.reduce((accumulator, item) => {
        accumulator[item.id] = item;
        return accumulator;
    }, {});

    const projectsIds: number[] = [];
    const estimatesIds: number[] = [];
    const executors: Employee[] = [];
    const executorsIds: number[] = [];

    tasks.forEach((task) => {
        const project_id = task.project_id;
        const estimate_id = task.estimate_id;
        const tags = task.context?.tags;

        if (task.involved?.executor_id && !executorsIds.includes(task.involved?.executor_id)) {
            const executor = employees.find(
                (employee) => employee.id === task.involved.executor_id
            );
            executorsIds.push(task.involved?.executor_id);
            executors.push(executor);
        }

        if (estimate_id && !estimatesIds.includes(estimate_id)) {
            estimatesIds.push(estimate_id);
        }

        if (project_id && !projectsIds.includes(project_id)) {
            projectsIds.push(project_id);
        }

        if (tags) {
            tags.forEach((tag) => {
                if (!tagsEntities[tag]) {
                    tagsEntities[tag] = allTagsEntities[tag];
                }
            });
        }
    });

    const projectsForFilter = allProjects
        .filter((project) => projectsIds.includes(project.id))
        .map((project) => {
            const { estimates, ...projectsData } = project;
            const filteredEstimates = estimates.filter((estimate) =>
                estimatesIds.includes(estimate.id)
            );
            return { ...projectsData, estimates: filteredEstimates };
        });

    allProjects.forEach((project) => {
        if (projectsIds.includes(project.id)) {
        }
    });

    const executorsResult = executors
        .sort((a, b) => {
            if (a.current_user === true) return -1;
            if (b.current_user === true) return 1;
            return 0;
        })
        .map((executor) =>
            executor.current_user ? { ...executor, name: `Я (${executor.name})` } : executor
        );
    const tags = Object.values(tagsEntities);
    return {
        projectsForFilter,
        executors: executorsResult,
    };
};
